export const CommonStyles = {
  position: 'relative',
  width: '44px',
  height: '44px',
  p: '2px',
  mr: 1.5,
  cursor: 'pointer',
}

export const sxMR0 = {
  mr: 0,
};

export const StyledIcon = (themeColor?: string) => ({
  position: 'absolute',
  width: '20px',
  height: '20px',
  top: '50%',
  left: '50%',
  mt: '-10px',
  ml: '-10px',
  color: themeColor || 'text.secondary',
})
